import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import "../style.scss";
import "./style.scss";
import CancelIcon from '@material-ui/icons/Cancel';
import { useDispatch, useSelector } from "react-redux";
import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";
import { addContactRequest, editContactRequest } from "../../../store/contacts/actions";
import PhoneInputComponent from "../../Controls/PhoneInput/PhoneInput";
import { arabicConvertor } from '../../../utils/Shared';

const AddContact = ({ intl: { messages }, show, close, patientId, selectedContact }) => {
     const lang = localStorage.getItem("lang") || "en";
     const dispatch = useDispatch();
     const [feedback, setFeedback] = useState(null);
     const [showConfirmation, setShowConfirmation] = useState(false);
     const { addedContact } = useSelector((state) => state.contacts);
     
     const [formData, setFormData] = useState({
        id: null,
        patient_id: patientId,
        name: {
            ar: '',
            en: ''
        },
        phone_number: '',
        email: '',
        relation: '',
        reason_of_contact: '',
    });

    const clear = () => {
        setFormData({
            id: null,
            patient_id: patientId,
            name: {
                ar: '',
                en: ''
            },
            phone_number: '',
            email: '',
            relation: '',
            reason_of_contact: '',
        });
        setFeedback(null);
        document.getElementById("contact_arname").style.borderColor = "#eee";
        document.getElementById("contact_enname").style.borderColor = "#eee";
        document.getElementById("contact_mobile").style.borderColor = "#eee";
        document.getElementById("contact_email").style.borderColor = "#eee";
        document.getElementById("contact_relation").style.borderColor = "#eee";
        document.getElementById("contact_reason").style.borderColor = "#eee";
    }

    const validation = () => {
        let isValid = true;
        if (formData?.reason_of_contact === '' ) {
            document.getElementById('contact_reason').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.contact_reason_placeholder);
        }
        if (formData?.relation === '') {
            document.getElementById('contact_relation').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.relation_placeholder);
        }
        /* if (formData?.email === '') {
            document.getElementById('contact_email').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.email_placeholder);
        } */
        if (formData?.phone_number === '') {
            document.getElementById('contact_mobile').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.mobile_placeholder);
        }
        if (formData?.name?.en === '') {
            document.getElementById('contact_enname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.contact_nameen_placeholder);
        }
        if (formData?.name?.ar === '') {
            document.getElementById('contact_arname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.patients.form.contact_namear_placeholder);
        }
        return isValid;
    }

    // if Selected App
    useEffect(() => {
        if (selectedContact) {
            setFormData({
                ...formData,
                id: formData.id,
                name: {
                    ar: selectedContact.name?.ar,
                    en: selectedContact.name?.en
                },
                phone_number: selectedContact.phone_number?.replace(/\+/g, ""),
                email: selectedContact.email,
                relation: selectedContact.relation,
                reason_of_contact: selectedContact.reason_of_contact,
            });
        } else {
            clear();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedContact]);

    //Clear and close
    useEffect(() => {
        if (addedContact) {
            clear();
            close();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addedContact]);

    return (
        <div className={`add-contact-modal_container ${show && " show"} ${lang === 'ar' && 'rtlPosition'}`}>
            <div className="add-contact-modal_container_content">
                    <CancelIcon onClick={close} className="add-contact-modal_container_content_close" />
                <div className="add-contact-modal_container_content_header">
                    <h4>{selectedContact ? messages.patients.contacts.edit_title : messages.patients.contacts.add_title}</h4>
                </div>
                <div className="add-contact-modal_container_content_body">
                    <form>
                        <div className="row">
                            <div className="col-md-6">
                                <label htmlFor="contact_arname" className='required'>{messages.patients.form.contact_namear}</label>
                                <input type="text" name="contact_arname" id="contact_arname"
                                        placeholder={messages.patients.form.contact_namear_placeholder}
                                        value={formData.name?.ar}
                                        onChange={e => {
                                            document.getElementById('contact_arname').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ 
                                                ...formData, 
                                                name: { ...formData.name, ar: arabicConvertor(e.target.value) }
                                            });
                                            }} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="contact_enname" className='required'>{messages.patients.form.contact_nameen}</label>
                                <input type="text" name="contact_enname" id="contact_enname"
                                        placeholder={messages.patients.form.contact_nameen_placeholder}
                                        value={formData.name?.en}
                                        onChange={e => {
                                            document.getElementById('contact_enname').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ 
                                                ...formData,
                                                name: { ...formData.name, en: e.target.value }
                                            })
                                            }} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label htmlFor="contact_mobile" className='required'>{messages.patients.form.mobile}</label>
                                <PhoneInputComponent name="contact_mobile" id="contact_mobile" lang={lang}
                                    myplaceholder={messages.users.form.mobile_placeholder}
                                    myvalue={formData.phone_number?.replace(/\+/g, "")}
                                    onValueChange={(val) => {
                                        document.getElementById('contact_mobile').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ 
                                            ...formData, 
                                            phone_number: val
                                        })
                                        }}
                                    />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="contact_email">{messages.patients.form.email}</label>
                                <input type="text" name="contact_email" id="contact_email"
                                        placeholder={messages.patients.form.email_placeholder}
                                        value={formData.email}
                                        onChange={e => {
                                            document.getElementById('contact_email').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ 
                                                ...formData, 
                                                email: e.target.value
                                            })
                                            }} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label htmlFor="contact_relation" className='required'>{messages.patients.form.relation}</label>
                                <input type="text" name="contact_relation" id="contact_relation"
                                        placeholder={messages.patients.form.relation_placeholder}
                                        value={formData.relation}
                                        onChange={e => {
                                            document.getElementById('contact_relation').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ 
                                                ...formData,
                                                relation: e.target.value
                                            })
                                            }} />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="contact_reason" className='required'>{messages.patients.form.contact_reason}</label>
                                <input type="text" name="contact_reason" id="contact_reason"
                                        placeholder={messages.patients.form.contact_reason_placeholder}
                                        value={formData.reason_of_contact}
                                        onChange={e => {
                                            document.getElementById('contact_reason').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ 
                                                ...formData, 
                                                reason_of_contact: e.target.value
                                            })
                                            }} />
                            </div>
                        </div>
                        <div className="contact_actions">
                                <button className="cancel" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        close();
                                        }}>
                                        {messages.patients.form.btn_cancel}                           
                                </button>
                                <button onClick={(e) =>  {
                                    e.preventDefault();
                                    if (selectedContact) {
                                        dispatch(editContactRequest({ ...formData, phone_number: `+${formData.phone_number}` }));
                                    } else if (validation()) {
                                        dispatch(addContactRequest({ ...formData, phone_number: `+${formData.phone_number}` }));
                                    }
                                    }} >
                                    {messages.patients.form.btn_save}
                                </button>
                        </div>
                        <p id="feedback"><span style={{ background: '#FFF' }}>{feedback}</span></p>
                    </form>   
                </div>
            </div>
            <ConfirmDialog show={showConfirmation} 
                     onCancel={() => setShowConfirmation(false)}
                     onConfirm={() => {
                        setShowConfirmation(false);
                        clear();
                        close();
                     }}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
        </div>
    );
}
export default injectIntl(AddContact);
